import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appRoutes } from '../config/docFile';

const TitleSetter = () => {
  const location = useLocation();
  const { pathname } = location;

  const pathWithoutLang = pathname.replace(/^\/[^/]+/, '') || '/';

  useEffect(() => {
    const currentRoute = appRoutes.find(route => `/${route.path}` === pathWithoutLang);
    document.title = currentRoute?.title || 'Default Title';
  }, [pathWithoutLang]);

  return null;
};

export default TitleSetter;